import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';

/** Common KPI report chrome: back link, title and a controls slot. */
export default function ReportShell({ title, controls, children }) {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: 'auto' }}>
      <Button component={RouterLink} to="/kpis" startIcon={<ArrowBackIcon />} size="small" sx={{ mb: 1 }}>
        Back to KPIs
      </Button>
      <Stack direction="row" alignItems="center" sx={{ mb: 2, flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="h5" sx={{ flexGrow: 1 }}>{title}</Typography>
        {controls}
      </Stack>
      {children}
    </Box>
  );
}
